import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  getAllValues(storageName: string): Record<string, any>{
    let valuesJSONString = localStorage.getItem(storageName);
    if(!valuesJSONString){
      return {};
    }
    return JSON.parse(valuesJSONString);
  }

  getValue(requestKey: string, storageName: string): any{
    return this.getAllValues(storageName)[requestKey];
  }

  saveValue(requestKey: string, storageName: string, values = null){
    let valuesToSave: Record<string, any> = this.getAllValues(storageName);
    valuesToSave[requestKey] = values;
    localStorage.setItem(storageName, JSON.stringify(valuesToSave));
  }
}
